import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";

// import hashSHA256 from "../helperFunctions/hashSHA256";

import Navbar from "../Component/LandingV2/Navbar";
import { UserInfo } from "../context/AuthContext";
import hashSHA256 from "../utils/hashSHA256";
import "./RegisterPage.scss";

export interface RegisterPageProps {
  setUserInfo: (userInfo: UserInfo) => void;
}

const RegisterPage = (props: RegisterPageProps) => {
  // Form state
  const [loadingState, setLoadingState] = useState(false);
  const [messageState, setMessageState] = useState<string | null>(null);
  const [errorState, setErrorState] = useState<string | null>(null);
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    // Dont refresh page
    e.preventDefault();
    // Reset states
    setLoadingState(true);
    setErrorState(null);
    setMessageState(null);

    try {
      // Setting explicit type for e.target to prevent using external libraries
      const eTarget = e.target as typeof e.target & {
        email: { value: string };
        password: { value: string };
        confirmPassword: { value: string };
      };

      // Destructure values for easier access
      const [username, email, password, confirmPassword] = [
        eTarget.email.value.split("@")[0],
        eTarget.email.value,
        eTarget.password.value,
        eTarget.confirmPassword.value,
      ];
      // console.log(username, email, password, confirmPassword);

      // Validate password is the same as confirm password
      if (password !== confirmPassword) {
        setErrorState("Confirm Passwords do not match");
        return;
      }

      // Send post request to backend
      const res = await fetch(
        `${process.env.REACT_APP_AUTH_URL || "http://localhost:3000"}/register`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({
            username,
            email,
            passwordHash: await hashSHA256(password),
            // passwordHash: password,
          }),
        }
      );

      const resData = await res.json();
      console.log(resData);
      // If successful, redirect to register page
      if (res.ok) {
        setMessageState(
          "User registered successfully 🎉 Please Verify your Email and Login."
        );
        // Set user info
        // props.setUserInfo({
        //   username: resData.username,
        //   email: resData.email,
        //   // scopes: resData.scopes,
        // });
        // Redirect to register page
        setTimeout(() => {
          console.log("Redirecting now");
          // window.location.href = "/";
          navigate("/");
        }, 2000);
      } else {
        // If unsuccessful, display error message
        throw new Error(resData?.message || "Could not register user");
      }
    } catch (err: any) {
      setErrorState(err?.message || "Could not register user");
    } finally {
      setLoadingState(false);
    }
  };

  return (
    <div className="register-page-root">
      <Navbar />
      <div className="register-split-page">

      {/* ── LEFT PANEL ── */}
      <div className="register-left-panel">

        {/* Brand */}
        {/* <div className="lp-brand">
          <img src="/assets/images/landingv2/main-logo.png" alt="AlgoFabric" className="lp-brand-logo" />
          <span className="lp-brand-name">AlgoFabric</span>
        </div> */}

        {/* Center text */}
        <div className="lp-center-text">
          <h2 className="lp-center-heading">
            AlgoFabric: A Financial<br />Insights Companion
          </h2>
          <p className="lp-center-body">
            With the power of NLP, AlgoFabric crafts precision stock reports — the
            perfect financial strategy for your journey.
          </p>
        </div>

        {/* Bottom spacer to balance brand at top */}
        <div className="lp-bottom-spacer" />

      </div>

      {/* ── RIGHT PANEL ── */}
      <div className="register-right-panel">
        <div className="register-form-card">
          <h2 className="register-title">Create Account</h2>
          <p className="register-subtitle">Start your journey with AlgoFabric</p>

          <form onSubmit={onSubmit} className="register-form">
            <div className="form-field">
              <label htmlFor="email" className="field-label">Email Address</label>
              <input
                id="email"
                className="input-field"
                type="text"
                name="email"
                placeholder="you@company.com"
                autoComplete="email"
              />
            </div>

            <div className="form-field">
              <label htmlFor="password" className="field-label">Password</label>
              <input
                id="password"
                className="input-field"
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Create a strong password"
                autoComplete="new-password"
              />
            </div>

            <div className="form-field">
              <label htmlFor="confirmPassword" className="field-label">Confirm Password</label>
              <input
                id="confirmPassword"
                className="input-field"
                type="password"
                name="confirmPassword"
                placeholder="Re-enter your password"
                autoComplete="new-password"
              />
            </div>

            <label htmlFor="terms" className="terms-label">
              <input
                type="checkbox"
                name="terms"
                id="terms"
                className="terms-checkbox"
              />
              <span>
                I agree to the <Link to="/terms">Terms of Service</Link> and{" "}
                <Link to="/privacy">Privacy Policy</Link>
              </span>
            </label>

            <button
              type="submit"
              className="register-button"
              disabled={loadingState}
            >
              {loadingState && (
                <Icon icon="akar-icons:loading" className="animate-spin" />
              )}
              {loadingState ? "Creating Account..." : "Create Account"}
            </button>
          </form>

          {errorState && (
            <p className="feedback-message feedback-message--error">{errorState}</p>
          )}
          {messageState && (
            <p className="feedback-message feedback-message--success">{messageState}</p>
          )}

          <div className="redirect-login">
            Already have an account?{" "}
            <Link to="/login">Log In</Link>
          </div>
        </div>
      </div>

      </div>
    </div>
  );
};

export default RegisterPage;
